module.exports = __webpack_public_path__ + "static/media/stck.b28ff33a.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/public/login/stck.png
// module id = 120
// module chunks = 0